export default __webpack_public_path__ + "static/media/1v1_diamond_header.a1c12d4e.png";